import { createElement, useMemo } from 'react';
import classnames from "classnames";
import dayjs from 'dayjs';
import { getLunarText } from './tool';
export const prefixCls = 'au-calendar';
export const Header = () => {
    const prefix = `${prefixCls}-header`;
    const list = ['一', '二', '三', '四', '五'];
    return (createElement("ul", { className: prefix },
        createElement("li", { className: `${prefix}-item ${prefixCls}-weekly` }, "\u661F\u671F\u65E5"),
        list.map(_ => (createElement("li", { key: _, className: `${prefix}-item` },
            "\u661F\u671F",
            _))),
        createElement("li", { className: `${prefix}-item ${prefixCls}-weekly` }, "\u661F\u671F\u516D")));
};
export const DayDom = ({ d, isWeekend, showLunar, showFest, festColor, selectedColor, selectedDate, onSelectDate }) => {
    const lunar = useMemo(() => d ? getLunarText(d) : { lunar: '', fest: '' }, [d]);
    const lunarText = useMemo(() => showFest ? lunar.fest || lunar.lunar : lunar.lunar, [showFest, lunar]);
    const isFest = useMemo(() => lunarText.includes('月') || lunarText === lunar.fest, [lunarText, lunar]);
    const isSelected = useMemo(() => d ? d.format('YYYY-MM-DD') === dayjs(selectedDate).format('YYYY-MM-DD') : false, [d, selectedDate]);
    const lunarColor = useMemo(() => {
        let color = '';
        if (isFest)
            color = festColor;
        if (isSelected)
            color = selectedColor;
        return color;
    }, [isSelected, selectedColor, festColor, isFest]);
    return (createElement("div", { className: classnames(`${prefixCls}-month-td`, { 'weekly': isWeekend }), onClick: () => onSelectDate(d.format('YYYY-MM-DD')) },
        createElement("div", { className: `${prefixCls}-month-td-num`, style: { color: isSelected ? selectedColor : '' } }, d ? d.format('DD') : ''),
        showLunar ? (createElement("div", { className: classnames(`${prefixCls}-month-td-text`, {
                'start': isWeekend || isFest
            }), style: { color: lunarColor } }, lunarText)) : null));
};
